<template>
  <div class="search-filter-item">
    <div class="font-medium">{{ $(label) }}</div>
    <slot></slot>
    <slot name="right">
      <div class="flex">
        <feather-icon icon="Trash2Icon"
                      class="cursor-pointer" style="width:20px; height: 20px; color: #7E72F2;"
                      @click="remove"
        />
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "SearchFilterItem",
  props: {
    label: String,
  },
  methods: {
    remove() {
      this.$emit('remove')
    }
  }
}
</script>

<style scoped>
.search-filter-item {
  width: 100%;
  display: grid;
  grid-template-columns: 114px 1fr auto;
  gap: 14px;
  align-items: center;
}
</style>
